import { render, staticRenderFns } from "./parkInCard.vue?vue&type=template&id=31b1f86d&scoped=true"
import script from "./parkInCard.vue?vue&type=script&lang=js"
export * from "./parkInCard.vue?vue&type=script&lang=js"
import style0 from "./parkInCard.vue?vue&type=style&index=0&id=31b1f86d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1f86d",
  null
  
)

export default component.exports